import {
  AfterViewInit,
  ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-multiple-select',
  templateUrl: './multiple-select.component.html',
  styleUrls: ['./multiple-select.component.scss']
})
export class MultipleSelectComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  // option data
  @Input() data: any;
  @Input() required: boolean;
  @Input() disabled: boolean;
  @Input() label: string;
  @Input() reset: boolean;
  @Input() defaultAll: boolean;
  
  // selected values
  @Input() values: any[] = [];

  @Output() result: EventEmitter<any[]> = new EventEmitter<any[]>();

  @ViewChild('allSelected') allSelected: MatOption;
  @ViewChild('multiple') multiple: MatSelect;

  matSelectSearchCtrl: FormControl = new FormControl();

  filteredData: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  protected onDestroy = new Subject<void>();
  public model: any[];
  countdownTimeoutIndex: any;
  constructor(
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    // listen for search field value changes
    this.matSelectSearchCtrl.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        if (this.countdownTimeoutIndex) {
          clearTimeout(this.countdownTimeoutIndex);
        }
        this.countdownTimeoutIndex = setTimeout(() => {
          this.filterBanksMulti();
        }, 1000);
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data) {
      this.filteredData.next(this.data.slice());
      if (this.defaultAll) {
        this.model = (['All'].concat(this.data));
      }
    }
    if (changes.values) {
      if (this.values.length === this.data.length) {
        this.model = (['All'].concat(this.data));
      } else {
        this.model = this.values;
      }
    }
    // if (this.reset) {
    //   this.model = (['All'].concat(this.data));
    //   // this.allSelected.deselect();
    // }
  }

  ngAfterViewInit() {
    this.setInitialValue();
  }

  ngOnDestroy() {
    this.onDestroy.next();
    this.onDestroy.complete();
  }

  optionChanges() {
    if (this.allSelected.selected) {
      this.allSelected.deselect();
      return false;
    }
    if (this.model.length === this.data.length) {
      this.allSelected.select();
    }
  }

  optionAllChanges() {
    // if (this.matSelectSearchCtrl.value) {
    //   this.matSelectSearchCtrl.setValue('');
    // }
    if (this.allSelected.selected) {
      this.model = ['All'].concat(this.data.slice());
    } else {
      this.model = [];
      this.allSelected.deselect();
    }
  }

  openedChange(opened: boolean) {
    if (!opened) {
      this.result.emit(this.model);
    }
  }

  filterBanksMulti() {
    if (!this.data) {
      return;
    }
    // get the search keyword
    let search = this.matSelectSearchCtrl.value;
    if (!search) {
      this.filteredData.next(this.data.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredData.next(
      this.data.filter(item => item.name.toLowerCase().indexOf(search) > -1)
    );
  }

  setInitialValue() {
    this.filteredData
      .pipe(take(1), takeUntil(this.onDestroy))
      .subscribe(() => {
        // setting the compareWith property to a comparison function
        // triggers initializing the selection according to the initial value of
        // the form control (i.e. _initializeSelection())
        // this needs to be done after the filteredBanks are loaded initially
        // and after the mat-option elements are available
        this.multiple.compareWith = (a: any, b: any) => a && b && a.name === b.name;
      });
  }

}

